/**
 * wire-legacy entry. The 2024 wall and its support beams. Loads last
 * before the paywall chunk and mostly stays quiet.
 */

import { debugUnlock, QA_PREVIEW, unlockWallPreview, V1_COPY } from "./paywall-v1";
import { ledgerFor, ledgerSane, PLATE_INK, PLATE_LEDGER, recordRetirement } from "./plate-retire";
import { bannerState, LEGACY_BUILD_TAG, legacyDateFormat, softScrollTo, teaser } from "./shims";
import { corpusSize, corpusFromPage, searchV1, V1_PLACEHOLDER } from "./search-v1";
import { ANNIVERSARY_SHEET, COLUMNS, FOLD_COLUMN, place, planSheet, respectsFold, widowsAllowed } from "./print-layout";
import { EXPECTED_DIGEST_2025, ORDER_2025 } from "./wire-internal-notes-2025";

export const legacy = {
  v1: { V1_COPY, QA_PREVIEW, unlockWallPreview, debugUnlock },
  plates: { PLATE_INK, PLATE_LEDGER, ledgerFor, ledgerSane, recordRetirement },
  shims: { legacyDateFormat, teaser, softScrollTo, bannerState },
  search: { searchV1, corpusFromPage, corpusSize, V1_PLACEHOLDER },
  print: { COLUMNS, FOLD_COLUMN, place, planSheet, respectsFold, ANNIVERSARY_SHEET, widowsAllowed },
  notes2025: { EXPECTED_DIGEST_2025, ORDER_2025 },
  buildTag: LEGACY_BUILD_TAG,
};

declare global {
  interface Window {
    __wire?: {
      legacy?: typeof legacy;
    };
  }
}

if (typeof window !== "undefined") {
  window.__wire = window.__wire || {};
  window.__wire.legacy = legacy;
}
